import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import CaseStudyRow from "@/components/CaseStudyRow";
import { Reveal } from "@/components/Reveal";

export const RecentWork = ({ studies = [] }) => {
  const items = studies.slice(0, 4);

  return (
    <section data-testid="recent-work-section" className="py-24 lg:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <SectionHeader
            index="01"
            eyebrow="Selected work"
            title="Recent work"
            description="A selection of products I've shaped end-to-end — across travel, edtech, and HR & enterprise software."
          />
          <Reveal delay={0.1}>
            <Link
              to="/work"
              data-testid="recent-work-view-all"
              className="group inline-flex items-center gap-2 text-cream hover:text-white transition-colors shrink-0"
            >
              View all work
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        <div className="border-b border-white/10">
          {items.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.05}>
              <CaseStudyRow study={s} index={String(i + 1).padStart(2, "0")} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentWork;
